<template>
  <div class="row" v-if="can_access('deal','view')">
    <h1 class="">Deal Tickets</h1><a v-b-toggle="'collapse-1'" variant="info"><i class="fa fa-info"></i></a>
    <div class="col-sm-12 p-0 mb-2">
      <b-collapse id="collapse-1">
        <b-card>
          <p><b><u>Stamp Duty</u></b></p>
          <p><b>Stamp Duty = 0 Default (Editable)</b></p>
          <p><b>Stamp Duty = 0.5%</b> If Type/Side = "BUY", ISIN Starts with GB and No exemption available</p>
          <p><b>Stamp Duty = 0 (Non Editable)</b> If Type/Side = "BUY", ISIN Starts with GB and Exemption available</p><br/>
          <p><b><u>Exemption calculation:</u></b></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;If Type/Side = "BUY", ISIN Starts with GB, Currency is GBP, Exchange Name is London &amp; within "EXEMPTION START DATE &amp; EXEMPTION END DATE"</p><br/>
          <p><b><u>Commission</u></b></p>
          <p><b>Commission = 0 Default</b></p>
          <!-- <p><b>Commission = 1%</b> for Type/Side in "BUY, SELL, FOP IN, FOP OUT, TRANSFER IN, TRANSFER OUT, GIVE IN, GIVE UP, DVP IN, DVP OUT"</p><br/> -->
          <p><b><u>PTM Levy</u></b></p>
          <p><b>PTM Levy = 0 Default</b></p>
          <p><b>PTM Levy = 1 GBP </b> if Capacity in "DEAL, AOTC, GIVEIN" and Trade Value >= 10,000 GBP and Currency is GBP and Type in "BUY, SELL, FOP IN, FOP OUT, TRANSFER IN, TRANSFER OUT, GIVE IN, GIVE UP, DVP IN, DVP OUT"</p>
        </b-card>
      </b-collapse>
    </div>
    <div class="col-sm-12">
      <b-button class="btn-info pull-right" @click="showAddDealForm=showAddDealForm?false:true" title="Add Deals" v-if="can_access('deal','modify')"><i :class="showAddDealForm?'fa fa-minus':'fa fa-plus'"></i></b-button>
    </div>
    <div v-if="showAddDealForm && can_access('deal','modify')">
      <AddDealForm :forceRerender="tradeFormReRender" :rows="{
        'action': 'create'
      }"/>
    </div>
    <div class="row col-md-12 p-0 mb-2" v-if="can_access('deal','modify')">
      <div class="col-md-6 form-group">
        <label></label>
      </div>
      <div class="col-md-4 form-group">
        <label>Trade Date</label>
        <date-picker input-class="form-control" ref="report_date" value-type="format" :range="true" type="date" v-model="report_date" format='DD-MM-YYYY'></date-picker>
      </div>
      <div class="col-md-2 form-group">
        <label>Status</label>
        <select name="type" class="form-control" v-model="status">
          <option selected value="1">Approved</option>
          <option selected value="-1">Unapproved</option>
          <option value="0">Cancelled</option>
          <option value="2">All</option>
        </select>
      </div>
    </div>
    <TableView :col="columns" :getData="getData" :DownloadURL="can_access('deal','download')?DownloadURL:''" v-if="showAddDealList && can_access('deal','view')" :Options="{filetype_options:[{ value: 'xlsx', text: '.xlsx' }],filenameprefix:'DealTickets-'}"/>
    <b-modal ref="view-deal-out" :title="'View Deal'" size="xl" hide-footer>
      <AddDealForm :rows="row" />
    </b-modal>
    <!-- <b-modal ref="get_filename" :title="'Set Filename'" size="md" hide-footer @hidden="setFilename">
      <div class="form-group">
        <label>Filename</label>
        <b-input-group>
          <template v-slot:prepend v-if="filenameprefix">
            <b-input-group-text >{{filenameprefix}}</b-input-group-text>
          </template>
          <b-form-input ref="file_name" v-model="filename" placeholder="Enter filename here.."></b-form-input>
          <template v-slot:append>
            <b-form-select v-model="filetype" :options="filetype_options"></b-form-select>
          </template>
        </b-input-group>
        <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click="download($event,'click')">Generate</button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'DealPage',
  components: { Widget, AddDealForm: () => import('@/components/Accounts/AddDealForm'), DatePicker, TableView },
  mixins: [common],
  data() {
    return {
      row: {
        'action': 'create'
      },
      showAddDealForm: 0,
      showAddDealList: 1,
      DateFilter: '',
      status: 2,
      DownloadURL: '',
      errorMessage: null,
      report_date: [moment().subtract(30, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
      columns: (() => {
        const cols = [
          { title: 'Approve', tdComp: 'tradeApprove', visible: this.can_access('deal_approve','view') },
          { title: 'Contract Note', field: 'contract_note', thComp: 'FilterTh', tdStyle: {'text-decoration':'underline dashed'},sortable: true, tdOnClick:this.ShowDealDetail},
          { title: 'Ticket Number', field: 'ticket_number', thComp: 'FilterTh' },
          { title: 'Broker Ref.', field: 'broker_ref' },
          { title: 'Acc. No.', field: 'account_number', thComp: 'FilterTh', tdStyle: {padding: this.can_access('deal','modify')?"":"0.8rem !important"}},
          { title: 'Security Type', field: 'type_of_security', tdComp: 'tradeSecurityType'},
          { title: 'Ticker', field: 'stock', nested: 'tidm', thComp: 'FilterTh'},
          { title: 'Issuer Name', field: 'stock', nested: 'issuer_name', thComp: 'FilterTh'},
          { title: 'Side', field: 'type', thComp: 'FilterTh', sortable: true, tdStyle: (row) => {if(row.type_total_quantity == 1 || row.type == 'FX') return {color: "green"};else /* if(["SELL","WITHDRAWAL","TRANSFER OUT","FOP OUT"].indexOf(row.type)>=0) */ return {color: 'red'};}},
          { title: 'Currency', field: 'currency', thComp: 'FilterTh'},
          { title: 'Quantity', field: 'total_quantity', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'Broker Trade Price', field: 'broker_trade_price', sortable: true , tdComp: 'Number'},
          { title: 'Client Trade Price', field: 'trade_price', sortable: true , tdComp: 'Number'},
          { title: 'Cosideration', field: 'total_consideration', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Trade Date', field: 'trade_date', sortable: true },
          { title: 'Settlement Date', field: 'settlement_date', sortable: true },
          /*{ title: 'Security ID (ISIN)', field: 'stock', nested: 'isin'},*/
          /* { title: 'Trade Value', field: 'trade_value', sortable: true, tdComp: 'Number'},
          { title: 'Cost Price', field: 'cost_price', tdComp: 'Number' },
          { title: 'Total Charges', field: 'total_other_charges', tdComp: 'Number' }, */
          { title: 'Notes', field: 'notes', thComp: 'FilterTh'},
          { title: 'Operation', tdComp: 'tradeOpt', visible: this.can_access('deal','modify') }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('deal', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    status: function(value){
      this.showAddDealList = false;
      this.$nextTick(function(){
        this.showAddDealList = true;
      });
    },
    "report_date": function(){
      this.showAddDealList = false;
      this.$nextTick(function(){
        this.showAddDealList = true;
      });
    },
  },
  methods: {
    ShowDealDetail(item){
      //console.log(item)
      item.action = 'view'
      this.row = item;
      this.$refs['view-deal-out'].show()
    },
    tradeFormReRender(response) {
      if(response.code==0){
        this.showAddDealForm = false;
        this.showAddDealList = false;
        this.$nextTick(function(){
          this.showAddDealForm = true;
          this.showAddDealList = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query={}, filter={}) {
      var { limit = 50, offset = 0, sort = 'trade_date', order = '' } = JSON.parse(JSON.stringify(query));
      if(!sort) sort = 'trade_date';

      this.columns.forEach(col => {
        if (query[col.nested||col.field]) {
          filter[col.nested||col.field] = query[col.nested||col.field];
        }else{
          delete filter[col.nested||col.field];
        }
      });
      
      filter['trade_date'] = {'from_date' : this.report_date[0], 'to_date': this.report_date[1]};
      this.DownloadURL = this.get_baseURL() +'download_deal_tickets?with_cancelled='+this.status+'&api_token='+ window.localStorage.getItem('auth_token') +'&limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter)
      let uri = 'trade_list?with_cancelled='+this.status+'&limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    },
  },
  created() {
    
  },
};
</script>